/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Fact_CmInputs */

const en_us2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const pt_br2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const es_419_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const pt_pt2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const fr_fr2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const de_de2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

const it_it2_profile_fact_cm = /** @type {(inputs: Profile_Fact_CmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cm`)
};

/**
* | output |
* | --- |
* | "cm" |
*
* @param {Profile_Fact_CmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_fact_cm = /** @type {((inputs?: Profile_Fact_CmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Fact_CmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_fact_cm(inputs)
	if (locale === "es-419") return es_419_profile_fact_cm(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_fact_cm(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_fact_cm(inputs)
	if (locale === "de-DE") return de_de2_profile_fact_cm(inputs)
	if (locale === "it-IT") return it_it2_profile_fact_cm(inputs)
	return en_us2_profile_fact_cm(inputs)
});
export { profile_fact_cm as "profile.fact_cm" }